/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Wizard_With_UnoInputs */



/**
* | output |
* | --- |
* | "Create it with Uno instead" |
*
* @param {Agent_Wizard_With_UnoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_with_uno = /** @type {((inputs?: Agent_Wizard_With_UnoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_With_UnoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Lieber mit Uno erstellen")
	return /** @type {LocalizedString} */ ("Create it with Uno instead")
});